import { render, staticRenderFns } from "./Beo.vue?vue&type=template&id=7810ffbc"
import script from "./Beo.vue?vue&type=script&lang=ts"
export * from "./Beo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports